module.exports = __webpack_public_path__ + "static/media/bottlings2.91fcd643.jpg";